module.exports = __webpack_public_path__ + "img/personnel_access_feature_02.2031bcd9.jpg";